$.fn.GridTitle = function() {
  let self = this

	self.siblings = self.closest('.row').find('.col')

	self.adjust = function() {
    var grid_header_height = 0;
		self.siblings.each(function() {
      var current_height = $(this).find('.grid__header').outerHeight()
      if (current_height > grid_header_height) {
        grid_header_height = current_height;
      }
    })
    self.siblings.each(function() {
      $(this).css('--grid-title-offset', grid_header_height + 'px')
    })
	}

  return function() {
		$(window).on('load resize orientationchange', function() {
			self.adjust();
		})
    return self
  }()
}
